export { default } from './FaqAccordionItem';
